import { Component } from "@angular/core";

import { GatewayView } from "../../gateway-view";
import { GatewayStatus } from "../../models";
import { GatewaysStatusService } from "../../gateways-status.service";

@Component({
	selector: "sdp-gateway-status",
	templateUrl: "./status.component.html",
	styleUrls: ["./_status-css.scss"]
})
export class StatusComponent {
	private _gateway: GatewayView | undefined;
	private _visibile = false;
	private _statuses: GatewayStatus[] = [];

	constructor(
		private service: GatewaysStatusService
	) { }

	public get gateway(): GatewayView | undefined {
		return this._gateway;
	}

	public set gateway(value: GatewayView | undefined) {
		this._gateway = value;
		if (!!this._gateway) {
			this.service.setGatewayStatus(this._gateway).then((statuses) => {
				this._statuses = statuses;
				this._visibile = true;
			}).catch(() => {
				// Do nothing on errors, just let the status column be empty
			});
		}
	}

	public get visible(): boolean {
		return this._visibile;
	}

	public get statuses() {
		return this._statuses;
	}
}
